import React, { Component } from 'react';
import PortalPageHeader from '../../common/PortalPageHeader';
import { Box, Container } from '@mui/material';
import { PageDetails } from '../config';
import { postData } from '../../../DataAccessLayer';
import { sam } from '../../../DataAccessLayer/services';
import { formatStudents } from '../utils';
import Filter from './Filter';
import ResultsTabs from './ResultsTabs';

class StudentSearch extends Component {
  state = {
    id: 'studentSearch',
    title: '',
    isLoading: true,
    students: [],
    notFoundStudents: [],
    isSearchResult: false,
    actionMenuItems: [],
    errorMessage: '',
    breadcrumbs: [],
  };

  componentDidMount() {
    this.loadPageTitle();
    this.loadBreadcrumbs();
  }

  //θ(1) Toggles isLoading
  toggleIsLoading = (isLoading = !this.state.isLoading) => {
    this.setState({
      isLoading,
    });
  };

  //θ(1) Toggles isLoading
  toggleIsSearchResult = (isSearchResult = !this.state.isSearchResult) => {
    this.setState({
      isSearchResult,
    });
  };

  //θ(N) where N is the number of pages in PageDetails
  //Retrieve page title from pageDetails using pageid
  loadPageTitle = () => {
    const page = Object.values(PageDetails).find((page) => page.id === this.state.id);
    this.setState({
      title: page.title,
    });
    this.toggleIsLoading(false);
  };

  loadBreadcrumbs = () => {
    const page = Object.values(PageDetails).find((page) => page.id === this.state.id);
    this.setState({
      breadcrumbs: page.breadcrumbs,
    });
  };

  //θ(1) Search students
  searchStudents = (studentsList) => {
    this.toggleIsSearchResult(true);
    this.toggleIsLoading(true);

    this.setState({
      students: [],
      notFoundStudents: [],
    });

    postData(sam.studentSearch, { students: studentsList }, true)
      .then((results) => {
        const students = formatStudents(results.students);
        this.setState({
          students,
          notFoundStudents: results.notFound,
          errorMessage: '',
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          errorMessage:
            'We’re currently experiencing an issue retrieving student data. Please try again later.',
        });
      })
      .finally((_) => {
        this.toggleIsLoading(false);
      });
  };

  render() {
    const id = this.state.id;

    return (
      <React.Fragment>
        <div id={`${id}__div_pageWrapper`} className={`myOdu__${id} myOdu__sam`} style={{}}>
          <Container id={`${id}__container_pageWrapper`} className="myOdu__container secondaryPage">
            <PortalPageHeader
              id={this.state.id}
              title={this.state.title}
              breadcrumbs={this.state.breadcrumbs}
            />

            <Filter
              id={id}
              onSearch={this.searchStudents}
              disablePrimaryButton={this.state.isLoading}
            />

            <Box id={`${id}__box_wrapper`} className={'wrapper'}>
              {this.state.isSearchResult && (
                <ResultsTabs
                  id={`${id}Tabs`}
                  students={this.state.students}
                  notFoundStudents={this.state.notFoundStudents}
                  isLoading={this.state.isLoading}
                  errorMessage={this.state.errorMessage}
                />
              )}
            </Box>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default StudentSearch;
